define('lq/conditions/conditionEvaluator',[
    'underscore',
    'when',
    'lq/events/processEventActionsUrl',
    './operandEvaluator'
], function (_, when, processEventActionsUrl, OperandEvaluator) {

    var ConditionEvaluator = function (condition, piping) {
        if (!condition.expression)
            throw new Error('The condition "' + condition.name + '" has an empty expression.');

        this.conditionName = condition.name;
        this.piping = piping;

        this.expression = this.prepareExpression(condition.expression);
        this.name = condition.name;

        this.operands = _.map(condition.operands, function (operand) {
            return new OperandEvaluator(operand, piping);
        });
    };

    ConditionEvaluator.prototype.evaluate = function () {
        var d = when.defer();

        if (this.result !== undefined) {
            d.resolve(this.result);
        } else {
            var dataSources = this.findAllDataSources();

            var self = this;
            var evaluate = function (queryResults) {
                self.result = self.evaluateOperands(queryResults);
                d.resolve(self.result);
            };

            if (dataSources.length === 0) {
                evaluate();
            } else {
                this.runQueries(dataSources)
                    .done(
                        function (queryResults) {
                            evaluate(queryResults);
                        },
                        $.noop); // let the global error handling code handle any errors
            }
        }

        return d.promise;
    };

    ConditionEvaluator.prototype.findAllDataSources = function () {
        var dataSources = [];

        _.each(this.operands, function (operand) {
            if (operand.leftValue.dataSource)
                dataSources.push(operand.leftValue.dataSource);
            if (operand.rightValue.dataSource)
                dataSources.push(operand.rightValue.dataSource);
        });

        return dataSources;
    };

    ConditionEvaluator.prototype.runQueries = function (dataSources) {
        dataSources = _.uniq(dataSources, function (dataSource) {
            return dataSource.id;
        });

        var piping = this.piping;
        
        return piping.dispatcher
            .dispatch(processEventActionsUrl.get(piping, 'Conditions', this.name), {
                actionId: piping.actionId,
                globalParameters: piping.parameters.globals.getAll(),
                localParameters: piping.parameters.locals.getAll(),
                requests: _.map(dataSources, function (dataSource) {
                    return {
                        eventActionType: 'ExecuteQuery',
                        actionId: piping.actionId,
                        rootMorphId: dataSource.rootMorphId,
                        queryObjectName: dataSource.id,
                        queries: [
                            {
                                listeners: [],
                                params: {
                                    page: 0,
                                    pageSize: 1
                                }
                            }
                        ]
                    };
                })
            })
            .then(function (results) {
                return _.object(_.map(results.responses, function (response, i) {
                    var data = response.Results[0].Result.Results.length > 0 ? response.Results[0].Result.Results[0] : {};
                    return [dataSources[i].id, data];
                }));
            });
    };

    ConditionEvaluator.prototype.evaluateOperands = function (queryResults) {
        var executableExpression = this.expression;

        _.each(this.operands, function (operand) {
            var value = operand.evaluate(queryResults);
            var nameToReplace = '(^| |\\()(' + operand.name + ')((?= |$|\\)))';
            executableExpression = executableExpression.replace(new RegExp(nameToReplace, 'g'), '$1' + value + '$3');
        });

        return eval('(' + executableExpression + ')');
    };

    ConditionEvaluator.prototype.clearResult = function () {
        delete this.result;
    };

    ConditionEvaluator.prototype.prepareExpression = function (expression) {
        return expression
            .replace(/ and /gi, ' && ')
            .replace(/ or /gi, ' || ');
    };

    return ConditionEvaluator;
});
